
<script setup>

  import AudioPlayer from '../components/audio-player.vue';

  import audio from '../audio/maxine-*.mp3';

  import track from '../audio/maxine-*.vtt';

  const players = [ {

    id: 1,

    title: 'A Typical Day'

  }, {

    id: 2,

    title: 'Having Fun, Feeling Safe'

  }, {

    id: 3,

    title: 'Around the Campgrounds'

  } ].map( obj => ( { ...obj, audio: audio[ obj.id ], track: track[ obj.id ] } ) );

</script>

<template>

  <p>Waitress and Visitor</p>

  <div v-for="{ audio, track, title } in players" class="mt-6" >

    <h4 class="font-bold">{{ title }}</h4>

    <AudioPlayer class="mt-4" :src="audio" :track="track" />

  </div>

  <div class="mt-8 text-xs italic">

    Source: Interview with Maxine Tutt, August 7, 2007. Original audio unavailable; this oral history was re-recorded by voiceover artists.

  </div>

</template>
